enum EPdfType {
  Default = 'PADRAO',
  Linear = 'LINEAR',
}

export default EPdfType;
